<template>
  <b-modal title="Itens da Prioridade" v-model="show" size="xl">
    <div class="modal-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE ITENS :::::::::::::::::::::::::::: -->
      <b-table bordered hover small head-variant="light" :items="getItens" :fields="fields.prioridadeItem">
        <template #cell(data)="data">
          <div>
            <p class="pt-0 pb-0">
              {{ moment(data.item.data).format("DD/MM/YYYY") }}
            </p>
          </div>
        </template>

        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="delServico(data.item)">
              <b-icon icon="trash-fill" variant="danger"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>

    <item-edit-modal ref="prioridadeItemEdit" @update="update()" />
    <confirm-modal ref="confirmPrioridadeItem" :descricao="'Deseja realmente remover o item ?'" @executar="executar()" />

    <template #modal-footer>
      <b-button class="pl-2 pr-3" variant="info" @click="adicionar()">
        <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
      </b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { usePrioridadeStore } from "@/stores/PrioridadeStore";
import { useEquipamentoStore } from "@/stores/EquipamentoStore";
import TableFields from "@/tools/TableFields";
import Prioridade from "@/models/Prioridade";
import PrioridadeItem from "@/models/PrioridadeItem";
import ItensEditModal from "@/components/modals/armazem/ItensEditModal.vue";
import ConfirmModal from "@/components/modals/diversos/ConfirmModal";

export default {
  name: "PrioridadeItensListModal",

  components: {
    "confirm-modal": ConfirmModal,
    "item-edit-modal": ItensEditModal,
  },

  data() {
    return {
      show: false,
      fields: new TableFields(),
      prioridade: new Prioridade(0, "Nova Prioridade", "", "", new Date(), "não atendida"),
      itens: [],
      item: new PrioridadeItem(0, "", "Novo Item", 0, 0, new Date()),
    };
  },

  methods: {
    editar(item) {
      item.prioridade = this.prioridade;
      this.$refs.prioridadeItemEdit.call(item);
    },

    adicionar() {
      let item = new PrioridadeItem(0, "", "Novo Item", 0, 0, new Date());
      item.prioridade = this.prioridade;
      this.$refs.prioridadeItemEdit.call(item);
    },

    delServico(item) {
      this.item.update(item);
      this.$refs.confirmPrioridadeItem.call();
    },

    executar() {
      this.prioridadeStore.REMOVER_ITEM(this.item.id).then(() => {
        this.update();
      });
    },

    update() {
      this.prioridadeStore.LISTAR_ITENS(this.prioridade.id).then(() => {
        this.item = new PrioridadeItem(0, "", "Novo Item", 0, 0, new Date());
        this.itens = this.getItens;
      });
    },

    call(prioridade) {
      this.show = !this.show;
      this.prioridade = prioridade;
      this.update();
    },
  },

  setup() {
    const store = useSgcqStore();
    const prioridadeStore = usePrioridadeStore();
    const equipamentoStore = useEquipamentoStore();
    const { getItens } = storeToRefs(prioridadeStore);

    return {
      store,
      prioridadeStore,
      equipamentoStore,
      getItens,
    };
  },
};
</script>

<style lang="scss" scoped></style>
